import React from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react';
import { toProperCase } from 'utils/formatting';

const DeleteModal = ({ isOpen, onClose, onDelete, selectedItem = "", isLoading }) => {
  // Handler for deleting the item
  // const handleDelete = () => {
  //   if (onDelete) {
  //     onDelete();
  //   }
  //   onClose(); // Close the modal after deletion
  // };

  const handleDelete = () => {
    if (onDelete) onDelete();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        borderRadius="16px"
        pb="16px"
        maxWidth={{ base: '90%', md: '448px' }}
        maxH="90vh"
        overflowY="auto"
        className="chakra-delete-modal"
      >
        <ModalHeader color="red.500">Delete Confirmation</ModalHeader>
        <ModalCloseButton color="red.500" _hover={{ color: 'red.700' }} />
        <ModalBody>
          <Text>
            Are you sure you want to delete{' '}
            <span
              style={{
                display: "inline",
                fontWeight: "600",
                color: "#ee5d50",
              }}
            >
              {toProperCase(selectedItem)}?
            </span>

          </Text>
          <Text mt={2} color="gray.500">
            This action cannot be undone.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" colorScheme="blackAlpha" onClick={onClose} mr={3}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={handleDelete} isLoading={isLoading}>
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteModal;
